<template>
  <div class="content-devx transparent headers-initial">
    <div>
      <table>
        <tr>
          <th class="head" />
          <th class="head" />
          <th class="head">
            Evaluación
          </th>
          <th class="head">
            Recomendaciones
          </th>
        </tr>
        <tr
          v-for="(item, index) in resultProject.result.soil_nutritional_inform.var"
          :key="index"
        >
          <td style="text-align: center;">
            {{ item }}
          </td>
          <td style="text-align: center;">
            {{ computedTexture(index) }}
          </td>
          <td style="text-align: center;">
            {{ resultProject.result.soil_nutritional_inform.Eval[index] }}
          </td>
          <td style="text-align: center;">
            {{ computedReco(index) }}
          </td>
        </tr>
      </table>
    </div>
    <f7-block-footer
      class="content-action-botton"
    >
      <f7-link
        popover-open=".popover-menu"
        data-popover=".links-popover"
        class="dx-btn-success dx-btn-see-more sm-popover"
      >
        {{ $t('seeMore') }}
      </f7-link>
      <f7-popover class="popover-menu links-popover">
        <f7-list>
          <f7-list-item
            link="/manureResult/detailManure/"
            popover-close
            :title="$t('result.manure.seasonal_recommendation_nutrient_concentration')"
          />
        </f7-list>
      </f7-popover>
      <f7-button
        class="dx-btn-cancel color-GreenHouse"
        raised
        type="default"
        styling-mode="outlined"
        name="ButtonCancel"
        @click="goToHomePage"
      >
        {{ $t('button_back') }}
      </f7-button>
    </f7-block-footer>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { NUMBER_OF_DECIMALS, TO_FIXED_DECIMALS_IN_TABLES } from '../../../js/constants';

export default {
  name: 'GroundNut',
  components: {
  },
  data() {
    return {
      data: [],
      NUMBER_OF_DECIMALS,
      TO_FIXED_DECIMALS_IN_TABLES,
    };
  },
  computed: {
    ...mapState('authentication', [
      'selection',
    ]),
    ...mapState('Result', [
      'resultProject',
    ]),
    selectionClass() {
      return this.selection === 'GreenHouse' ? 'dx-btn-success color-orange' : 'dx-btn-success open-air';
    },
  },
  beforeMount() {
    this.$f7.preloader.show();
    const reducer = (accumulator, curr) => accumulator + curr;

    if (this.TO_FIXED_DECIMALS_IN_TABLES) {
      this.data.texture = this.resultProject.ground.ground_name;
      this.data.irrigation_volume = this.resultProject.result.irrigation_volume
        .reduce(reducer).toFixed(1);
    } else {
      this.data.texture = this.resultProject.ground.ground_name;
      this.data.irrigation_volume = this.resultProject.result.irrigation_volume
        .reduce(reducer);
    }
    this.$f7.preloader.hide();
  },
  methods: {
    goToHomePage() {
      this.$f7.views.main.router.navigate('/tabs-result-greenhouse/', { reloadCurrent: true });
    },
    computedTexture(index) {
      let result = '';
      if (this.resultProject.result
          && this.resultProject.result.soil_nutritional_inform
          && this.resultProject.result.soil_nutritional_inform.Value) {
        try {
          result = this.resultProject.result.soil_nutritional_inform.Value[index].toFixed(1);
        } catch (_) {
          result = this.resultProject.result.soil_nutritional_inform.Value[index];
        }
      }
      return result;
    },
    computedReco(index) {
      let result = '';
      if (this.resultProject.result
          && this.resultProject.result.soil_nutritional_inform
          && this.resultProject.result.soil_nutritional_inform.Reco) {
        try {
          result = this.resultProject.result.soil_nutritional_inform.Reco[index].toFixed(1);
        } catch (_) {
          result = this.resultProject.result.soil_nutritional_inform.Reco[index];
        }
      }
      return result;
    },
  },
};
</script>
<style
    lang="scss"
    scoped
>
.boton-greenHouse {
  background: #FF7F26;
  height: 30px;
  width: 100px;
  margin-top: 60px;
  text-align: center;
}
.boton-openAir {
  background: #51A411;
  height: 30px;
  width: 100px;
  margin-top: 60px;
  text-align: center;
}
.content-checkbox {
  padding-top: 50px;
  padding-left: 40px;
}
.content-devx {
  height: 500px !important;
}
.head {
  font-weight: 700;
  text-align: center;
  background: #F4F5F7 !important;
  font-family: 'Roboto';
  line-height: 16px;
  color: #616B7C;
  padding: 0.5rem;
}
table {
  margin-left: auto;
  margin-right: auto;
  border-spacing: 0;
}
th {
  padding: 0.5rem;
  border:1px solid #C0C9CE;
}
td {
  padding: 0.5rem;
  background: white;
  border:1px solid #C0C9CE;
}
</style>
